import { render } from "./reduction_head.vue?vue&type=template&id=7b37cdf9"
import script from "./reduction_head.vue?vue&type=script&lang=js"
export * from "./reduction_head.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/reduction/inside/fields/reduction_head.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b37cdf9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b37cdf9', __exports__)) {
    console.log('reload')
    api.reload('7b37cdf9', __exports__)
  }
  
  module.hot.accept("./reduction_head.vue?vue&type=template&id=7b37cdf9", () => {
    console.log('re-render')
    api.rerender('7b37cdf9', render)
  })

}


export default __exports__